import type { ReactNode } from "react"

import PartnerLayoutTemplate from "@/layouts/partner/partner-sidebar-layout"

export default function PartnerLayout({ children }: { children: ReactNode }) {
  return <PartnerLayoutTemplate>{children}</PartnerLayoutTemplate>
}
